import App from './App.vue'
import Meta from 'vue-meta'
Vue.use(Meta)
const Home = require('./home').default
const QueryResult = require('./query-result.vue').default
const Info = require('./info').default
const Infointro = require('./info-intro').default
const Register = require('./register').default
const Companyservice = require('./company-service').default
const Payment = require('./Payment/selPay').default
const PaySuccess = require('./Payment/components/PaySuccess').default
const ConfirmOrder = require('./confirm-order').default
const AppDetail = require('./app-detail').default
const DomainTransform = require('./domain-transform').default
const DomainTransformRegister = require('./domain-transform-register').default
const PriceTable = require('./price-table').default
const ErrorPage = require('./404').default
const BuyCompanyPackageServer = require('./buy-company-package-server').default
const NewHome = require('./new-domain-index').default
const Trademark = require('./trademark').default
const RegisterTrademark = require('./register-trademark')
const routes = [
    {
        path: '/domain/home',
        component: Home
    },
    {
        path: '/domain',
        component: NewHome
    },
    {
        path: '/domain/result',
        component: QueryResult
    },
    {
        path: '/domain/info',
        component: Info
    },
    {
        path: '/domain/info-intro/:lang/:suffix',
        component: Infointro
    },
    {
        path: '/domain/register',
        component: Register
    },
    // {
    //     path: '/domain/price-table',
    //     component: PriceTable
    // },
    {
        path: '/domain/buy-company-package-server',
        component: BuyCompanyPackageServer
    },
    {
        path: '/domain/company-service',
        component: Companyservice
    },
    {
        path: '/domain/trademark',
        component: Trademark
    },
    {
        path: '/domain/payment/selPay/:orderid',
        component: Payment
    },
    {
        path: '/domain/payment/paysuccess/:ordercode',
        component: PaySuccess
    },
    {
        path: '/domain/confirm/:data',
        component: ConfirmOrder
    },
    {
        path: '/domain/app-detail/:code',
        component: AppDetail
    },
    {
        path: '/domain/domain-transform',
        component: DomainTransform
    },
    {
        path: '/domain/domain-transform-register',
        component: DomainTransformRegister
    },
    {
        path: '/domain/register-trademark',
        component: RegisterTrademark
    },
    {
        path: '/domain/404',
        component: ErrorPage
    }
]

const router = new VueRouter({
    routes,
    mode: 'history',
    // mode: 'hash',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})

new Vue({
    el: '#app',
    router,
    render: (h) => h(App),
    mounted() {
        // You'll need this for renderAfterDocumentEvent.
        document.dispatchEvent(new Event('render-event'))
    }
})



// WEBPACK FOOTER //
// ./src/main.js